import { useCurrentBreakpoint } from "@/hooks/use-breakpoint";

export const setStyleByBreakpoint = (styleClass: object) => {
	const breakpoint = useCurrentBreakpoint();

	// Prioridade: base > sm > md > lg > xl > 2xl > 3xl
	const orderedBreakpoints = ["base", "sm", "md", "lg", "xl", "2xl", "3xl"];

	const currentIndex = orderedBreakpoints.indexOf(breakpoint);

	for (let i = currentIndex; i >= 0; i--) {
		const key = orderedBreakpoints[i] as keyof typeof styleClass;
		if (styleClass[key] && Object.keys(styleClass[key]).length > 0) {
			return styleClass[key];
		}
	}

	return {};
};
